"use client";
import { isBD } from "../../utils/businessType.lib.js";
import { ECO_FEE_CATEGORY } from "../../components/Product/EcoFee/constants.js";
import { getCompareProductButtonData, getReviewRatingData, getReplacementItemNumber, getProductNavigationUrl, getImageUrl, getProductFeaturesData, getProductDeliveryBadgeData, getProductActions, getDiscountsData, getPriceData, getPillBadges, getMemberOnlyData, getFsaEligibility, getChdiEligibility, getDeliveryChannelBadgeData, getColorSwatchesData, getInWareHouseChannelBadgeData, getInWarehouseAvailabilityText, getAddToListButtonData } from "./lib.js";
const normalizeProductApi = (responseData, productConfig, hasUserSignedId, cookieContext, keyword, isSponsored, isProductDetailsPage) => {
  var _a, _b, _c;
  const {
    pillBadgeConfig,
    imageConfig,
    featureToggleConfig,
    enabledWarehousesListConfig,
    translationsConfig
  } = productConfig || {};
  const { inventoryResponseData, productApiResponseData } = responseData || {};
  const { catalogData, childData, fulfillmentData } = ((_a = productApiResponseData == null ? void 0 : productApiResponseData.data) == null ? void 0 : _a.products) || {};
  const { warehouse, wcMember, deliveryLocation, bdDeliveryLocation } = cookieContext || {};
  const { nearestWarehouse } = warehouse || {};
  const bopiwWarehouseEnabled = Boolean(
    (_b = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesBOPIWList) == null ? void 0 : _b.some(
      (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
    )
  );
  const wioWarehouseEnabled = Boolean(
    (_c = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesWIOList) == null ? void 0 : _c.some(
      (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
    )
  );
  const normalizedData = catalogData == null ? void 0 : catalogData.map((item) => {
    var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
    const {
      itemNumber,
      itemId,
      description,
      locale,
      additionalFieldData,
      published,
      attributes
    } = item;
    const hasSingleSku = ((_a2 = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _a2.length) === 1;
    const productBrand = (_b2 = attributes == null ? void 0 : attributes.find(
      (attr) => attr.key === "Brand"
    )) == null ? void 0 : _b2.value;
    const taxableFoodItem = (_c2 = attributes == null ? void 0 : attributes.find(
      (attr) => attr.key === "Taxable_Food"
    )) == null ? void 0 : _c2.value;
    const publishedChildItems = {
      catalogData: (_d = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _d.filter(
        (cItem) => Boolean((cItem == null ? void 0 : cItem.published) && (cItem == null ? void 0 : cItem.parentId) === itemId)
      ),
      fulfillmentData: childData == null ? void 0 : childData.fulfillmentData
    };
    const { shortDescription, marketingStatement, auxDescription2 } = description || {};
    const isEcoFeeEligible = (additionalFieldData == null ? void 0 : additionalFieldData.linkFeeEligible) === 1;
    const isSwatchable = ((_e = item.fieldData) == null ? void 0 : _e.swatchable) === 1 && (publishedChildItems == null ? void 0 : publishedChildItems.catalogData) && ((_f = publishedChildItems == null ? void 0 : publishedChildItems.catalogData) == null ? void 0 : _f.length) > 1;
    const primaryCatalogItem = isSwatchable ? (_g = publishedChildItems == null ? void 0 : publishedChildItems.catalogData) == null ? void 0 : _g[0] : item;
    const swatchAttr = (_i = (_h = primaryCatalogItem == null ? void 0 : primaryCatalogItem.attributes) == null ? void 0 : _h.filter((aItem) => {
      return "swatchImage" in aItem && aItem["swatchImage"];
    })) == null ? void 0 : _i[0];
    const { swatchImage, key } = swatchAttr || {};
    const linkFeePrices = ((_l = (_k = (_j = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _j[0]) == null ? void 0 : _k.additionalFieldData) == null ? void 0 : _l.linkFeePrices) || (additionalFieldData == null ? void 0 : additionalFieldData.linkFeePrices) || [];
    const location = isBD() ? (_m = bdDeliveryLocation == null ? void 0 : bdDeliveryLocation.bdLocation) == null ? void 0 : _m.slice(-2) : deliveryLocation == null ? void 0 : deliveryLocation.state;
    const relevantLinkFeePrice = linkFeePrices == null ? void 0 : linkFeePrices.find(
      (linkFee) => linkFee.key === location
    );
    const ecoFee = relevantLinkFeePrice == null ? void 0 : relevantLinkFeePrice.fees.find(
      (fee) => fee.feeCategory === ECO_FEE_CATEGORY
    );
    return {
      addToListButtonData: getAddToListButtonData(
        item,
        shortDescription,
        hasSingleSku,
        cookieContext,
        publishedChildItems
      ),
      availabilityInfoData: {
        inWarehouseAvailabilityText: getInWarehouseAvailabilityText(item),
        inWarehouseChannelBadgeData: getInWareHouseChannelBadgeData(
          item,
          enabledWarehousesListConfig,
          cookieContext,
          (featureToggleConfig == null ? void 0 : featureToggleConfig.showMultiVariantsAvailability) || false,
          hasSingleSku,
          inventoryResponseData,
          publishedChildItems
        )
      },
      colorSwatchesData: getColorSwatchesData(
        translationsConfig,
        imageConfig,
        item,
        publishedChildItems,
        featureToggleConfig
      ),
      deliveryChannelData: {
        status: getDeliveryChannelBadgeData(
          item,
          bopiwWarehouseEnabled,
          wioWarehouseEnabled,
          inventoryResponseData
        )
      },
      isChdiEligible: getChdiEligibility(publishedChildItems),
      isEcoFeeEligible,
      isFsaEligible: getFsaEligibility(publishedChildItems),
      isMemberOnlyItem: getMemberOnlyData(item, publishedChildItems),
      isPublished: Boolean(published),
      locale: locale == null ? void 0 : locale.toLowerCase(),
      pillBadges: getPillBadges(
        item,
        pillBadgeConfig,
        imageConfig == null ? void 0 : imageConfig.domainUrl,
        keyword
      ),
      priceListData: getPriceData(
        item,
        hasSingleSku,
        cookieContext,
        !published ? childData : publishedChildItems,
        ecoFee,
        hasUserSignedId,
        isProductDetailsPage
      ),
      discountsData: getDiscountsData(
        !published ? childData : publishedChildItems
      ),
      // Unmodified price data. If this ever gets updated to include ecoFee, ensure the relevant UI components are updated to
      // not handle that logic themselves
      savingsData: {
        salePrice: (_p = (_o = (_n = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _n[0]) == null ? void 0 : _o.priceData) == null ? void 0 : _p.listPrice,
        listPrice: (_s = (_r = (_q = childData == null ? void 0 : childData.catalogData) == null ? void 0 : _q[0]) == null ? void 0 : _r.priceData) == null ? void 0 : _s.price
      },
      ecoFee,
      productActions: getProductActions(
        item,
        featureToggleConfig,
        translationsConfig,
        hasUserSignedId,
        wioWarehouseEnabled,
        bopiwWarehouseEnabled,
        hasSingleSku,
        (wcMember == null ? void 0 : wcMember.value) || "",
        inventoryResponseData,
        publishedChildItems,
        isSponsored,
        cookieContext,
        isProductDetailsPage
      ),
      productDeliveryBadgeData: getProductDeliveryBadgeData(
        item,
        translationsConfig,
        imageConfig == null ? void 0 : imageConfig.domainUrl
      ),
      productInfoData: {
        itemNumber: ((_t = catalogData == null ? void 0 : catalogData[0]) == null ? void 0 : _t.itemNumber) || "",
        partNumber: itemNumber,
        productBrand,
        productFeaturesData: getProductFeaturesData(
          auxDescription2 || ""
        ),
        productImageUrl: getImageUrl(primaryCatalogItem, item),
        productLinkUrl: getProductNavigationUrl(
          shortDescription,
          itemNumber,
          imageConfig == null ? void 0 : imageConfig.domainUrl,
          swatchImage,
          key,
          (_u = featureToggleConfig == null ? void 0 : featureToggleConfig.enableBModPDPNavigationUrl) == null ? void 0 : _u.isEnabled
        ),
        productName: shortDescription,
        replacementItemNumber: getReplacementItemNumber(fulfillmentData)
      },
      promoItem: {
        promoText: marketingStatement || "",
        promoTextColor: ""
      },
      reviewRatingData: getReviewRatingData(
        item,
        translationsConfig
      ),
      showCompareProductButton: getCompareProductButtonData(item),
      taxableFoodItem,
      linkFeePrices
    };
  });
  return normalizedData;
};
export {
  normalizeProductApi
};
